import {
  MutationFunction,
  UseMutationOptions,
  useMutation,
} from '@tanstack/react-query';
import { TError, useHandleErrors } from './useHandleErrors';

export const useCustomMutation = <TData, TVariables, TContext>(
  mutationFn: MutationFunction<TData, TVariables>,
  options: Omit<
    UseMutationOptions<TData, TError, TVariables, TContext>,
    'mutationFn'
  > = {}
) => {
  const { handleErrorsOnError, handleErrorsOnSuccess } = useHandleErrors();
  const { onError, onSuccess } = options;

  return useMutation(mutationFn, {
    ...options,
    onError: (error, variables, context) => {
      handleErrorsOnError(error);
      return onError?.(error, variables, context);
    },
    onSuccess: (data, variables, context) => {
      handleErrorsOnSuccess(data);
      return onSuccess?.(data, variables, context);
    },
  });
};
